// StickySection.js
import React from 'react';

const StickySection = ({ id, children }) => {
  return (
    <div id={id} className="sticky-section">
      {children}
    </div>
  );
};

export default StickySection;
